import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../../config/index';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import ProfileImage from "../../fileManager/Components/ProfileImage";
import LoadingButton from "../../../components/elements/LoadingButton";
import {connect, getStore, setStore} from "trim-redux";
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import Button from "@material-ui/core/Button/Button";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import {checkMelliCode, updateRedux} from "../../../../config/Security";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import SingleFileChooser from "../../fileManager/Components/SingleFileChooser";
import Typography from "@material-ui/core/Typography/Typography";
import GetConfirmationButton from "../../../components/elements/GetConfirmationButton";
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import FieldCounterWithoutBar from "../../../components/elements/FieldCounterWithoutBar";
import SendMessageToUserButton from "../../admin/users/SendMessageToUserButton";
import Feature from "../../../components/elements/Feature";
import AddTicketModalAdmin from "../../tickets/add_ticket/AddTicketModalAdmin";

class details extends React.Component {
    classes = this.props.classes
    state={
        fields: {
            name: '',
            email:'',
            mobile:'',
            first_name:'',
            last_name:'',
            melli_code:'',
            financial_code:'',
            admin_note:""
        },
        lock:true,
        errors:{},
        loading:true,
        SubmitLoading:false,
        confirmed:'',
        mobile_confirmed:false,
        melli_card:null,
        target_user:null,
    };
    componentDidMount(){
        this.loadData();
    }
    loadData(){
        let loginToken = localStorage.getItem('ACT');
        let {manage,user_id} = this.props;
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.get(`${defaultVariabls.url}/user/get/${manage ? user_id : this.props.user.id}`, config)
            .then(response => {
                this.setState({
                    fields:{
                        name: response.data.name,
                        first_name: response.data.first_name,
                        last_name: response.data.last_name,
                        melli_code:response.data.melli_code,
                        financial_code:response.data.financial_code,
                        admin_note: !!response.data.admin_note ? response.data.admin_note : '',
                        email:response.data.email,
                        mobile:response.data.mobile,
                    },
                    loading:false,
                    confirmed:response.data.confirmed,
                    melli_card:response.data.melli_card,
                    mobile_confirmed:response.data.mobile_confirmed,
                    target_user:response.data
                })
            })
            .catch(error => {
                this.setState({
                    loading:false
                })
            });
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({
            fields,
        });
    }
    handleValidation(callback){
        let { fields,melli_card } = this.state;
        let {user} = this.props;
        let errors = {};
        let formIsValid = true;

        try {
            //first_name
            if(validator.isEmpty(fields.first_name)){
                formIsValid = false;
                errors['first_name'] = Translate.emptyName;
            }else if(!validator.isByteLength(fields.first_name,{min:0, max:255})){
                formIsValid = false;
                errors['first_name'] = Translate.maxLength255;
            }
            //last_name
            if(validator.isEmpty(fields.last_name)){
                formIsValid = false;
                errors['last_name'] = Translate.emptyLastName;
            }else if(!validator.isByteLength(fields.last_name,{min:0, max:255})){
                formIsValid = false;
                errors['last_name'] = Translate.maxLength255;
            }
            if(!!fields.melli_code){
                if (!checkMelliCode(fields.melli_code)) {
                    formIsValid = false;
                    errors['melli_code'] = Translate.wrongMelliCode;
                }
            }else{
                formIsValid = false;
                errors['melli_code'] = Translate.emptyField;
            }

        }catch (e) {
            console.log(e)
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {fields,melli_card,confirmed,mobile_confirmed,lock} = this.state;
        let data = new FormData();
        data.append('first_name', fields.first_name);
        data.append('last_name', fields.last_name);
        data.append('melli_code', fields.melli_code);
        data.append('financial_code', fields.financial_code);
        data.append('admin_note', fields.admin_note);
        data.append('confirmed', confirmed);
        data.append('mobile_confirmed', mobile_confirmed);
        data.append('melli_card_id', !!melli_card ? melli_card.id : null);
        if(!lock){
            data.append('mobile', fields.mobile);
            data.append('email', fields.email);
        }
        let loginToken = localStorage.getItem('ACT');
        let {manage,user_id} = this.props;
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/user/set/${manage ? user_id : this.props.user.id}`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.detailsSet, {
                    variant: 'success',
                });
                this.setState({
                    SubmitLoading:false
                });
                if(!manage){
                    this.setState({
                        loading:true,
                        lock:true
                    })
                    if(!lock){
                        window.location.reload();
                    }else{
                        updateRedux();
                        this.loadData();
                    }

                }else{
                    this.setState({
                        loading:true,
                        lock:true
                    })
                    this.loadData();
                }
            })
            .catch(error => {
                console.log(error.response)
                if(error.response.status === 403){
                    this.props.enqueueSnackbar(Translate.mobileVerificationFailed, {
                        variant: 'error',
                    });
                }else if(error.response.status === 422){
                    this.props.enqueueSnackbar(Translate.anotherUserHasThisInfo, {
                        variant: 'error',
                    });
                }else{
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                }

                this.setState({
                    SubmitLoading:false
                });
            });
    }
    refreshStore(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.get(`${defaultVariabls.url}/checkLogin`, config)
                .then(response => {
                    setStore({
                        isAuth : true,
                        user : response.data,
                    });

                }).catch(error => {
                setStore({
                    isAuth : false,
                    user : null,
                });
            })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        });
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: this.state.confirmed === "confirmed" ? "pending" : "confirmed",
        })
    }
    loginToUserAccount(){
        let {mobile_confirmed} = this.state;
        if(!!mobile_confirmed){
            this.setState({
                loading:true
            })
            let loginToken = localStorage.getItem('ACT');
            let {user_id} = this.props;
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.get(`${defaultVariabls.url}/loginToUserAccount/${user_id}`, config)
                .then(async response => {
                    await localStorage.setItem('ADMIN_ACT',localStorage.getItem('ACT'));
                    await localStorage.setItem('ACT',response.data.accessToken);
                    await updateRedux();
                    let user = await getStore('user')
                    let username = user.mobile;
                    let login_token = user.login_token;
                    await window.location.replace(`${defaultVariabls.website}/loginFromPanel/${username}/${login_token}`);
                })
                .catch(error => {
                    this.setState({
                        loading:false
                    })
                });
        }else{
            this.props.enqueueSnackbar(Translate.userShouldConfirmMobileFirst, {
                variant: 'error',
            });
        }

    }
    render() {
        const {errors,fields,SubmitLoading,confirmed,melli_card,mobile_confirmed,lock} = this.state;
        let {purchase,user,manage,user_id,primary_color} = this.props;
        if (this.state.loading) {
            return (
                <AppCardLoaderFields/>
            )
        } else {
            return (
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12} md={11} lg={10}>
                    <Grid container  spacing={2} justify="center" alignItems="flex-start">
                        <CssBaseline/>
                        {/*<Grid item xs={12}>
                            {
                                manage ?
                                    !! user.role.permission.manageSettings &&
                                    <Alert
                                        severity={confirmed === "confirmed" ? 'success' : 'info'}
                                        action={
                                            <FormControlLabel
                                                style={{marginRight:10,color: !confirmed ? "#ed1d1d" : ""}}
                                                control={
                                                    <Switch
                                                        checked={confirmed === "confirmed"}
                                                        onChange={this.handleChangeConfirmed.bind(this)}
                                                        value={confirmed}
                                                        color="primary"
                                                    />
                                                }
                                                label={confirmed === "confirmed" ? Translate.confirmed : confirmed === "uncompleted" ? Translate.uncompleted :  Translate.pending}
                                            />
                                        }
                                    >
                                        {Translate.userConfirmationStatus}
                                    </Alert>
                                    :
                                confirmed === "uncompleted" ?
                                    <Alert severity="info">
                                        <AlertTitle>{Translate.welcomeUserTitle}</AlertTitle>
                                        {Translate.WelcomeUserText} <strong>{Translate.thankYou}</strong>
                                    </Alert>
                                    :
                                    confirmed === "confirmed" ?
                                        <Alert  severity="success">
                                            {Translate.yourAccountIsActive}
                                        </Alert>
                                        :
                                        <Alert  severity="warning">
                                            {Translate.yourAccountIsInChecking}
                                        </Alert>
                            }
                        </Grid>*/}
                        {
                            !!purchase ? null :
                                <Grid item xs={12} md={3} style={{textAlign:"center"}}>
                                    {
                                        !!user.role.permission.manageSettings &&
                                            <>
                                                <Feature check="login_to_user_account">
                                                    <Button
                                                        style={{marginBottom:20,marginTop:20,width:"100%"}}
                                                        startIcon={<LockOpenRoundedIcon/>}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => this.loginToUserAccount()}
                                                    >
                                                        {Translate.loginToUserAccount}
                                                    </Button>
                                                </Feature>
                                                <Feature check="admin_message">
                                                    <AddTicketModalAdmin
                                                        receiver={this.state.target_user}
                                                        style={{marginTop:15,marginBottom:20,width:"100%"}}
                                                        reload={() => console.log("reload")}
                                                    />
                                                </Feature>
                                        </>
                                    }

                                    <ProfileImage manage={this.props.manage} user_id={this.props.user_id}/>
                                </Grid>
                        }
                        <Grid item xs={12} md={9}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        value={fields.first_name}
                                        fullWidth
                                        id="first_name"
                                        label={Translate.first_name}
                                        name="first_name"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['first_name']}
                                        helperText={errors['first_name']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        value={fields.last_name}
                                        fullWidth
                                        id="last_name"
                                        label={Translate.last_name}
                                        name="last_name"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['last_name']}
                                        helperText={errors['last_name']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.melli_code}
                                        fullWidth
                                        required
                                        label={Translate.melli_code}
                                        name="melli_code"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['melli_code']}
                                        helperText={errors['melli_code']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.financial_code}
                                        fullWidth
                                        label={Translate.financial_code}
                                        name="financial_code"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['financial_code']}
                                        helperText={errors['financial_code']}
                                    />
                                </Grid>
                                {
                                    !!purchase ? null :
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    value={fields.mobile}
                                                    fullWidth
                                                    id="mobile"
                                                    disabled={lock}
                                                    label={Translate.mobile}
                                                    name="mobile"
                                                    autoComplete="mobile"
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['mobile']}
                                                    helperText={errors['mobile']}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    value={fields.email}
                                                    fullWidth
                                                    id="email"
                                                    disabled={lock}
                                                    label={Translate.email}
                                                    name="email"
                                                    autoComplete="email"
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['email']}
                                                    helperText={errors['email']}
                                                />
                                            </Grid>
                                        </>
                                }
                                {
                                    manage &&
                                    <Grid item xs={12}>
                                        {
                                            mobile_confirmed ?
                                                <Typography style={{color: "#38bf84"}}>{Translate.userMobileIsConfirmed}</Typography>
                                                :
                                                <Typography style={{color: "#bfb20d",display:"flex",alignItems:"center"}}>
                                                    <span>
                                                    {Translate.userMobileIsNotConfirmed}
                                                    </span>
                                                    <GetConfirmationButton
                                                        handleAction={() => this.setState({mobile_confirmed:1})}
                                                        question={Translate.doYouWanaConfirm}
                                                        icon={<CheckBoxRoundedIcon/>}
                                                        color={primary_color}
                                                        tooltip={Translate.confirm}
                                                    >
                                                        <CheckBoxRoundedIcon fontSize="small" style={{color:primary_color}}/>
                                                    </GetConfirmationButton>
                                                </Typography>
                                        }
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    {
                                        !!lock ?
                                            <Button
                                                onClick={() => this.setState({lock:false})}
                                                color="primary"
                                            >
                                                {Translate.changeMobileOrEmail}
                                            </Button>
                                            :
                                            <Typography >{Translate.changeMobileOrEmailDesc}</Typography>
                                    }

                                </Grid>
                                {
                                    manage &&
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            multiline
                                            minRows={6}
                                            value={fields.admin_note}
                                            fullWidth
                                            label={Translate.admin_note}
                                            name="admin_note"
                                            onChange={this.handleChange.bind(this)}
                                            error = {!!errors['admin_note']}
                                            helperText={errors['admin_note']}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <FieldCounterWithoutBar length={!!fields.admin_note ? fields.admin_note.length : 0} max={1000}/>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick = {this.handleSubmit.bind(this)}
                            loading = {SubmitLoading}
                        >
                            {Translate.setDetails}
                        </LoadingButton>
                    </Grid>
                    </Grid>
                </Grid>
            );
        }
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(details))));